module.exports = __webpack_public_path__ + "static/media/openapi_logo.631b10a9.svg";